import contentData from './content.json';

export interface DirectDebitAlertContent {
	actionRequired: boolean;
	actionRequiredContent: null | string;
	messageContent: null | string;
	displayRecommendedAmount: boolean;
}

export default function getDirectDebitAlertContent(isToleranceLimitNull: boolean, isMetered: boolean, recommendedAmount:number, paymentAmount: number, paymentFrequency: string) {

	const directDebitAlertContent: DirectDebitAlertContent = {
    	actionRequired: false,
    	actionRequiredContent: null,
    	messageContent: null,
    	displayRecommendedAmount: false,
	};

	if (contentData.dashboard.directDebitMessages.useDefaultMessaging) {
		directDebitAlertContent.actionRequired = contentData.dashboard.directDebitMessages.default.actionRequired;
    	directDebitAlertContent.actionRequiredContent = contentData.dashboard.directDebitMessages.default.actionRequiredMessage;
    	directDebitAlertContent.messageContent = contentData.dashboard.directDebitMessages.default.message;
		directDebitAlertContent.displayRecommendedAmount = contentData.dashboard.directDebitMessages.default.displayRecommendedAmount;

    	return directDebitAlertContent;
	}

	if ((!isToleranceLimitNull && !isMetered) || (isMetered && (recommendedAmount && recommendedAmount > paymentAmount))) {
    	directDebitAlertContent.actionRequired = contentData.dashboard.directDebitMessages.tooLow.actionRequired;
    	directDebitAlertContent.actionRequiredContent = contentData.dashboard.directDebitMessages.tooLow.actionRequiredMessage;
    	directDebitAlertContent.messageContent = contentData.dashboard.directDebitMessages.tooLow.message;
    	directDebitAlertContent.displayRecommendedAmount = contentData.dashboard.directDebitMessages.tooLow.displayRecommendedAmount;

    	return directDebitAlertContent;

	}

	if ((!isToleranceLimitNull && !isMetered) || (isMetered && (recommendedAmount && recommendedAmount < paymentAmount))) {
    	directDebitAlertContent.actionRequired = contentData.dashboard.directDebitMessages.tooHigh.actionRequired;
    	directDebitAlertContent.actionRequiredContent = contentData.dashboard.directDebitMessages.tooHigh.actionRequiredMessage;
    	directDebitAlertContent.messageContent = contentData.dashboard.directDebitMessages.tooHigh.message;
    	directDebitAlertContent.displayRecommendedAmount = contentData.dashboard.directDebitMessages.tooHigh.displayRecommendedAmount;

    	return directDebitAlertContent;
	}

	if (recommendedAmount && recommendedAmount === paymentAmount && paymentFrequency && paymentFrequency.toLowerCase() === 'monthly') {
		directDebitAlertContent.actionRequired = contentData.dashboard.directDebitMessages.regularlyAdjusted.actionRequired;
    	directDebitAlertContent.actionRequiredContent = contentData.dashboard.directDebitMessages.regularlyAdjusted.actionRequiredMessage;
    	directDebitAlertContent.messageContent = contentData.dashboard.directDebitMessages.regularlyAdjusted.message;
		directDebitAlertContent.displayRecommendedAmount = contentData.dashboard.directDebitMessages.regularlyAdjusted.displayRecommendedAmount;

    	return directDebitAlertContent;
	}
	directDebitAlertContent.actionRequired = contentData.dashboard.directDebitMessages.default.actionRequired;
    directDebitAlertContent.actionRequiredContent = contentData.dashboard.directDebitMessages.default.actionRequiredMessage;
    directDebitAlertContent.messageContent = contentData.dashboard.directDebitMessages.default.message;
	directDebitAlertContent.displayRecommendedAmount = contentData.dashboard.directDebitMessages.default.displayRecommendedAmount;

    return directDebitAlertContent;
}
